import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'vant/lib/index.css'
import {PullRefresh ,List ,Dialog ,Grid, GridItem,Popup ,AddressEdit ,AddressList ,Icon ,SwipeCell ,Stepper ,SubmitBar ,Checkbox, CheckboxGroup,Form ,Field ,Tag,Button,Image as VanImage, Swipe, SwipeItem,Lazyload,Badge,Sidebar, SidebarItem,Collapse, CollapseItem,Tab, Tabs,Card   } from 'vant';
createApp(App)
    .use(Swipe).use(SwipeItem).use(Lazyload,{
        // 当图片没有加载的时候，显示这张图片
        loading:require('./assets/images/01.jpg')
    }).use(Badge).use(Sidebar).use(SidebarItem).use(Collapse).use(CollapseItem)
    .use(Tab).use(Tabs).use(Card).use(VanImage).use(Tag).use(Button)
    .use(Form).use(Field).use(Checkbox).use(CheckboxGroup)
    .use(SubmitBar).use(Stepper).use(SwipeCell).use(Icon)
    .use(AddressEdit).use(AddressList)
    .use(Popup)
    .use(Grid)
    .use(GridItem)
    .use(Dialog)
    .use(List)
    .use(PullRefresh)
    .use(store).use(router).mount('#app')
